import React, { useEffect } from "react";
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";

function MediaLightbox({ gallery, language, onClose, onPrevious, onNext }) {
  useEffect(() => {
    if (!gallery) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft") onPrevious();
      if (event.key === "ArrowRight") onNext();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [gallery, onClose, onNext, onPrevious]);

  if (!gallery) return null;

  const closeLabel = language === "zh" ? "關閉圖片" : "Close image";
  const previousLabel = language === "zh" ? "上一張" : "Previous image";
  const nextLabel = language === "zh" ? "下一張" : "Next image";

  return (
    <div
      className="media-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={gallery.label}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="media-lightbox__bar">
        <div>
          <strong>{gallery.label}</strong>
          <span>{gallery.index + 1} / {gallery.items.length}</span>
        </div>
        <button type="button" onClick={onClose} aria-label={closeLabel} title={closeLabel}>
          <FiX aria-hidden="true" />
        </button>
      </div>

      <div className="media-lightbox__stage">
        {gallery.items.length > 1 && (
          <button
            type="button"
            className="media-lightbox__nav media-lightbox__nav--previous"
            onClick={onPrevious}
            aria-label={previousLabel}
            title={previousLabel}
          >
            <FiChevronLeft aria-hidden="true" />
          </button>
        )}
        <img src={gallery.items[gallery.index]} alt={`${gallery.label} ${gallery.index + 1}`} />
        {gallery.items.length > 1 && (
          <button
            type="button"
            className="media-lightbox__nav media-lightbox__nav--next"
            onClick={onNext}
            aria-label={nextLabel}
            title={nextLabel}
          >
            <FiChevronRight aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
}

export default MediaLightbox;
